import { z } from 'zod';

// A date as JSON carries one: the ISO-8601 string, or the epoch milliseconds
// some partners send. null is NOT a date — `new Date(null)` would silently read
// as 1970-01-01, so it is left for the date schema to report.
const coerceToDate = (value: unknown) =>
  typeof value === 'string' || typeof value === 'number'
    ? new Date(value)
    : value;

/**
 * A Date, parsed from the ISO-8601 string a body carries and from the Date a
 * normalized Firestore document holds (see normalizeDoc). Documents itself as
 * `string`/`date-time` in the OpenAPI spec, which is what a body actually
 * carries.
 *
 * @param requiredMessage reported when the value is missing or not a date
 */
export const dateValidation = (requiredMessage?: string) =>
  z
    .preprocess(coerceToDate, z.date(requiredMessage))
    .meta({ type: 'string', format: 'date-time' });
